import { defineStore } from 'pinia';
import axios from 'axios';
const userClientMatterOptionsStore = defineStore('clientMatterOptionsStore', {
  state: () => ({
    clientCount: 0,
    matterCount: 0,
    clientOptions: [],
    matterOptions: [],
    clientQuery: {
      originating: false,
      involved: false,
      reviewer: false,
      primary: false,
      scopeAccount: '',
      status: '',
      search: ''
    },
    matterQuery: {
      originating: false,
      involved: false,
      reviewer: false,
      primary: false,
      scopeAccount: '',
      archived: false,
      search: '',
      clientId: ''
    }
  }),
  actions: {
    async getClientCount(query, signal = null) {
      const url = '/clients/optionscount';
      const response = await axios({
        method: 'GET',
        url,
        params: query,
        signal
      });
      this.$patch({
        clientCount: response.data
      });
      return response.data;
    },
    async getMatterCount(query, signal = null) {
      const url = '/matters/optionscount';
      const response = await axios({
        method: 'GET',
        url,
        params: query,
        signal
      });
      this.$patch({
        matterCount: response.data
      });
      return response.data;
    },
    async getCopyMatter(query, signal = null) {
      const url = 'matters/copy';
      const response = await axios({
        method: 'GET',
        url,
        params: query,
        signal
      });
      return response.data;
    },
    async getClient(clientId, signal = null) {
      const url = '/clients/option';
      const response = await axios({
        method: 'GET',
        url,
        params: {
          clientId
        },
        signal
      });
      return response.data;
    },
    async listClientOptions(query, signal = null) {
      if (this.clientOptions.length > 0 && this.isClientQueryEqual(query)) {
        return this.clientOptions;
      }
      const url = '/clients/options';
      const response = await axios({
        method: 'GET',
        url,
        params: query,
        signal
      });
      this.$patch({
        clientOptions: response.data
      });
      this.$patch({
        clientQuery: {
          ...query
        }
      });
      return this.clientOptions;
    },
    async listMatterOptions(query, signal = null) {
      if (this.matterOptions.length > 0 && this.isMatterQueryEqual(query)) {
        return this.matterOptions;
      }
      const url = '/matters/options';
      const response = await axios({
        method: 'GET',
        url,
        params: query,
        signal
      });
      this.$patch({
        matterOptions: response.data
      });
      this.$patch({
        matterQuery: {
          ...query
        }
      });
      return this.matterOptions;
    },
    // Both comparisons include showSecondarySplitMatter because it changes which
    // records come back and the endpoints default it to false. Without it, a
    // page that asks for secondary split matters can be served a cached list
    // fetched by a page that didn't - and vice versa.
    isClientQueryEqual(query) {
      return this.clientQuery.originating === query.originating && this.clientQuery.involved === query.involved && this.clientQuery.reviewer === query.reviewer && this.clientQuery.primary === query.primary && this.clientQuery.scopeAccount === query.scopeAccount && this.clientQuery.status === query.status && this.clientQuery.showSecondarySplitMatter === query.showSecondarySplitMatter && this.clientQuery.search === query.search;
    },
    isMatterQueryEqual(query) {
      return this.matterQuery.originating === query.originating && this.matterQuery.involved === query.involved && this.matterQuery.reviewer === query.reviewer && this.matterQuery.primary === query.primary && this.matterQuery.scopeAccount === query.scopeAccount && this.matterQuery.status === query.status && this.matterQuery.showSecondarySplitMatter === query.showSecondarySplitMatter && this.matterQuery.clientId === query.clientId && this.matterQuery.search === query.search;
    }
  }
});
export default userClientMatterOptionsStore;